export const quillBackgroundColors: any = [
    '#2c3a4d', // dark theme color
    "#000000",
    "#e60000",
    "#ff9900",
    "#ffff00",
    "#008a00",
    "#0066cc",
    "#9933ff",
    "#ffffff",
    "#facccc",
    "#ffebcc",
    "#ffffcc",
    "#cce8cc",
    "#cce0f5",
    "#ebd6ff",
    "#bbbbbb",
    "#f06666",
    "#ffc266",
    "#ffff66",
    "#66b966",
    "#66a3e0",
    "#c285ff",
    "#888888",
    "#a10000",
    "#b26b00",
    "#b2b200",
    "#006100",
    "#0047b2",
    "#6b24b2",
    "#444444",
    "#5c0000",
    "#663d00",
    "#666600",
    "#003700",
    "#002966",
    "#3d1466",
]

// Enhanced color palette for Circle color picker (matching columns style)
export const highlightPickerColors: string[] = [
    // Dark mode background colors
    '#141520', // Main dark mode background
    '#1d1e2c', // Dark mode header/modal
    '#2C3A4D', // Dark mode cards/inputs
    // Column picker colors
    '#FF1B00',
    '#199347',
    '#8a2be2',
    '#FFA600',
    '#0000FF',
    '#D3D3D3',
    '#00F12C',
    '#000000',
    '#DF00D1',
    '#800000',
    // Standard colors
    '#FFFFFF',
    '#e60000',
    '#ff9900',
    '#ffff00',
    '#008a00',
    '#0066cc',
    '#9933ff',
    // Pastels
    '#facccc',
    '#ffebcc',
    '#ffffcc',
    '#cce8cc',
    '#cce0f5',
    '#ebd6ff',
]